export default function getSelectedActiveTablesFigures(activeTopicHRefSearchPath) {
    if (!activeTopicHRefSearchPath || activeTopicHRefSearchPath.length === 0) {
        return { selectedTopicHref: null, isTabFig: false, targetId: null };
    }
    const selectedTopicHref = activeTopicHRefSearchPath?.[activeTopicHRefSearchPath?.length - 1]?.selectedTopicHref ?? "";
    console.log("----getSelectedActiveTablesFigures selectedTopicHref ", selectedTopicHref, "header", activeTopicHRefSearchPath?.[activeTopicHRefSearchPath?.length - 1]?.header);
    const lastPart = selectedTopicHref?.split("/").pop();
    let isTabFig = false;
    if (selectedTopicHref) {
        const hasTblRef = /-tbl[A-Za-z0-9_-]*(\b|$)/i.test(selectedTopicHref);
        const hasBoxRef = /-box[A-Za-z0-9_-]*(\b|$)/i.test(selectedTopicHref);
        const hasFigRef = /fig-[A-Za-z0-9_-]*(\b|$)/i.test(selectedTopicHref);
        const hasTableRef = /table-[A-Za-z0-9_-]*(\b|$)/i.test(selectedTopicHref);
        isTabFig = hasTblRef || hasBoxRef || hasFigRef || hasTableRef;
    }
    let targetId = null
    if (isTabFig && selectedTopicHref) {
        const match = lastPart.match(/([A-Za-z0-9_-]*(?:-(tbl|box)[A-Za-z0-9_-]*|fig-[A-Za-z0-9_-]*|table-[A-Za-z0-9_-]*))(\b|$)/i);

        targetId = match ? match[1] : null;
        if (!targetId) {
            console.warn(`⚠️ Could not extract targetId from selectedTopicHref → ${selectedTopicHref}   `);
            return { selectedTabFig: selectedTopicHref, isTabFig, targetId: null };
        }
        // match[2] will be either "tbl" or "box"
        // Determine which type it is
        let type = null;
        if (/-tbl[A-Za-z0-9_-]*$/i.test(targetId)) type = "tbl";
        else if (/-box[A-Za-z0-9_-]*$/i.test(targetId)) type = "box";
        else if (/^fig-[A-Za-z0-9_-]*$/i.test(targetId)) type = "fig";
        else if (/^table-[A-Za-z0-9_-]*$/i.test(targetId)) type = "table";

        // ✅ Only prefix with "table-" if it's a tbl reference
        if (type === "tbl") {
            targetId = `table-${targetId}`;
        } else if (type === "table") {
            targetId = `table-${targetId}`;
        } if (type === "fig" || type === "box") {
            targetId = `fig#${targetId}`;
        }
    }

    return { selectedTableFigure: selectedTopicHref, isTableFigure: isTabFig, targetId };
}